export class AuthRequestContractError extends Error {
  constructor(detail) {
    super(`Invalid auth request: ${detail}`);
    this.name = 'AuthRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}
const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const text = value => typeof value === 'string' && value.trim().length > 0;
const password = value => typeof value === 'string' && value.length > 0;
export function readMemberRegistrationRequest(body) {
  if (!record(body) || !text(body.bahaiId) || !text(body.email)
    || body.eulaAcceptedAt != null && (typeof body.eulaAcceptedAt !== 'string' || !Number.isFinite(Date.parse(body.eulaAcceptedAt)))) {
    throw new AuthRequestContractError('expected Bahai ID, email text and an optional acceptance timestamp.');
  }
  return body;
}
export function readMemberVerificationRequest(body) {
  if (!record(body) || !text(body.bahaiId) || !text(body.verificationCode) || !password(body.password)) {
    throw new AuthRequestContractError('expected Bahai ID, verification code and password strings.');
  }
  return body;
}
export function readPasswordLoginRequest(body) {
  if (!record(body) || !text(body.email) || !password(body.password)) {
    throw new AuthRequestContractError('expected email and password strings.');
  }
  return body;
}
export function readRefreshTokenRequest(body) {
  if (!record(body) || !text(body.refreshToken)) throw new AuthRequestContractError('expected a refresh token string.');
  return body;
}
